import { Box } from '@chakra-ui/react';
import OutsideClickHandler from 'react-outside-click-handler';
import { useTranslation } from 'react-i18next';

import { Condition, Iteration } from 'Component/others';
import { CloseIcon } from 'Asset/icon';
import useGetScheduleDetail from 'Domain/schedule/useGetScheduleDetail';
import { TextMedium, TextRegular } from 'UiKit/typography';
import Alert from 'UiKit/alert';

import { useScheduleState } from 'View/schedule/state';
import BrandScheduleAccordion from 'View/schedule/component/brand-schedule-accordion';

import styles from './styles.module.css';

const DrawerDetailSchedule = () => {
  const { t } = useTranslation('schedule');
  const { filterState, state, updateState } = useScheduleState();
  const { isDrawerOpen, isEnableFetchDetail, selectedEvent, isDialogOpen } = state;
  const { data } = useGetScheduleDetail({
    enabled: isEnableFetchDetail,
    payload: {
      selectedEvent,
      ...filterState,
      hasActiveHost: true,
    },
  });

  const handleCloseDrawer = () => {
    if (isDialogOpen) return;
    updateState({
      selectedEvent: null,
      isDrawerOpen: false,
      isEnableFetchDetail: false,
    });
  };

  const alertDescription = t('noHostForSessionAlert', { count: selectedEvent?.noActiveHostScheduleCount });

  return (
    <Condition statement={isDrawerOpen}>
      <OutsideClickHandler onOutsideClick={handleCloseDrawer}>
        <Box className={styles['drawer__container']}>
          <Box className={styles['drawer__section--head']}>
            <Box>
              <TextMedium className={styles['drawer__text--time']}>{data?.timeText}</TextMedium>
              <TextRegular className={styles['drawer__text--date']}>{data?.date}</TextRegular>
            </Box>

            <CloseIcon className={styles['close__icon']} size="24px" onClick={handleCloseDrawer} />
          </Box>

          <Condition statement={selectedEvent?.noActiveHostScheduleCount > 0}>
            <Alert isOpen type="error" description={alertDescription} marginBottom="16px" showIcon={false} />
          </Condition>

          <Box className={styles['drawer__section--content']}>
            <Iteration
              items={data?.schedules}
              render={(item) => {
                return <BrandScheduleAccordion data={item} />;
              }}
            />
          </Box>
        </Box>
      </OutsideClickHandler>
    </Condition>
  );
};

export default DrawerDetailSchedule;
